<template>
  <div>
    <audio src="@/assets/audios/senhaNova.mp3"></audio>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row" v-if="setor && local">
        <div class="col-md-6">
          <h4>
            {{ setor_nome.length ? setor_nome + " (" + local_nome + ")" : "" }}
          </h4>
          <h6 style="line-height: 0">Senhas no setor: {{ senhas.length }}</h6>
        </div>
        <div class="col-md-2">
          <button
            class="btn btn-sm btn-primary m-0 w-100 d-flex justify-content-between align-items-center"
            @click="chamarProximo"
            :disabled="!senhas.length"
            style="height: 100%"
          >
            <span class="mr-1">Próxima Senha</span>
            <i class="fas fa-play"></i>
          </button>
        </div>
        <div class="col-md-2">
          <button
            class="btn btn-sm btn-danger m-0 w-100 d-flex justify-content-between align-items-center"
            @click="chamarProximoAusente"
            :disabled="!senhas.length"
            style="height: 100%"
          >
            <span class="mr-1">Próximo Ausente</span>
            <i class="fas fa-user-slash"></i>
          </button>
        </div>
        <div class="col-md-2">
          <button
            class="btn btn-sm btn-secondary m-0 w-100 d-flex justify-content-between align-items-center"
            @click="logoutChamador"
            style="height: 100%"
          >
            <span class="mr-1">Trocar de setor/local</span>
            <i class="fas fa-sign-out-alt"></i>
          </button>
        </div>
        <div class="col-12" style="overflow-x: auto">
          <table class="table triped mt-1">
            <thead>
              <tr class="py-1">
                <th width="5%" class="align-top text-center">
                  Episódio
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.id"
                    @change="filtrar"
                  />
                </th>
                <th width="10%" class="align-top text-center">
                  Senha
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.senha"
                    @change="filtrar"
                  />
                </th>
                <th
                  width="10%"
                  class="align-top text-center d-none d-md-table-cell"
                >
                  Demanda
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.demanda"
                    @change="filtrar"
                  />
                </th>
                <th
                  width="12%"
                  class="align-top text-center d-none d-md-table-cell"
                >
                  Questionário
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.questionario"
                    @change="filtrar"
                  />
                </th>
                <th
                  width="15%"
                  class="align-top text-center d-none d-md-table-cell"
                >
                  Pessoa
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.pessoa"
                    @change="filtrar"
                  />
                </th>
                <th width="13%" class="align-top text-center">
                  Notas
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.observacao"
                    @change="filtrar"
                  />
                </th>
                <th
                  width="10%"
                  class="align-top text-center d-none d-md-table-cell"
                  v-if="thisSetor && thisSetor.mostra_classificacao"
                >
                  Classificação de risco
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtro.classificacao"
                    @change="filtrar"
                  />
                </th>
                <th
                  width="10%"
                  class="align-top text-center d-none d-md-table-cell"
                >
                  Grupo Prioritário
                  <template v-if="prioridades && prioridades.length">
                    <v-select
                      v-model="filtro.prioridade_id"
                      :options="prioridades"
                      label="nome"
                      :reduce="(prioridade) => prioridade.id"
                      class="vselect"
                      @input="filtrar"
                      :clearable="true"
                      placeholder=""
                    />
                  </template>
                </th>
                <th
                  width="10%"
                  class="align-top text-center d-none d-md-table-cell"
                >
                  Status
                  <select
                    class="form-control"
                    v-model="filtro.status"
                    @change="filtrar"
                  >
                    <option value=""></option>
                    <option value="0">Ausente</option>
                    <option value="1">Em fila</option>
                    <option value="2">Em atendimento</option>
                    <option value="8">Espera</option>
                    <option value="9">Reavaliação</option>
                  </select>
                </th>
                <th
                  width="10%"
                  class="align-top text-center d-none d-lg-table-cell"
                >
                  Tempo na fila
                </th>
                <th width="8%" class="align-top text-left">Ações</th>
              </tr>
            </thead>
            <tbody v-if="senhas && senhas.length">
              <tr
                v-for="senha in senhas"
                :key="senha.id"
                style="border-bottom: 1px solid #888"
              >
                <td class="text-center align-center">
                  <b>{{ senha.atendimento ? senha.atendimento.id : "" }}</b>
                </td>
                <td class="text-center align-center">
                  <b v-if="senha.atendimento">
                    {{ senha.atendimento.prefixo
                    }}{{ senha.atendimento.senha }}
                    {{ senha.atendimento.atendimento_id_pai ? "(Subsenha)" : ""
                    }}<br />
                    ({{ senha.atendimento.data_inicio_f }})
                  </b>
                </td>
                <td class="d-none d-md-table-cell align-center text-center">
                  <template v-if="senha.atendimento">
                    {{
                      senha.atendimento.botao_id && senha.atendimento.botao
                        ? senha.atendimento.botao.nome
                        : "Consulta agendada"
                    }}
                    <span
                      v-if="
                        senha.atendimento.botao &&
                        senha.atendimento.botao.linha_cuidado
                      "
                    >
                      <br />({{ senha.atendimento.botao.linha_cuidado.nome }})
                    </span>
                  </template>
                </td>
                <td class="d-none d-md-table-cell align-center text-center">
                  <template
                    v-if="
                      senha.atendimento &&
                      senha.atendimento.questionario &&
                      senha.atendimento.questionario.length
                    "
                  >
                    <div
                      v-for="(linha, indice) in resumoQuestionario(
                        senha.atendimento.questionario
                      )"
                      :key="indice"
                    >
                      <span :title="linha.pergunta">{{ linha.respostas }}</span>
                    </div>
                  </template>
                  <template v-else>-</template>
                </td>
                <td class="d-none d-sm-table-cell">
                  <template
                    v-if="
                      senha.atendimento &&
                      senha.atendimento.pessoa &&
                      (senha.atendimento.pessoa.nome_social ||
                        senha.atendimento.pessoa.nome) &&
                      String(
                        senha.atendimento.pessoa.nome_social ||
                          senha.atendimento.pessoa.nome
                      ).toLowerCase() !== 'null'
                    "
                  >
                    {{
                      (senha.atendimento.pessoa.nome_social ||
                        senha.atendimento.pessoa.nome) +
                      (senha.atendimento.pessoa.data_nascimento &&
                      senha.atendimento.pessoa.data_nascimento_f
                        ? " (" +
                          senha.atendimento.pessoa.data_nascimento_f +
                          ", " +
                          (senha.atendimento.pessoa.diff_idade || "") +
                          ")"
                        : "")
                    }}
                  </template>
                  <template v-else>Não identificado</template>
                  <!-- Flag de edição de nome pendente -->
                  <span
                    v-if="senha.edicao_nome_pendente"
                    class="badge badge-warning ml-1"
                    style="font-size: 0.75em"
                    :title="'Nome solicitado: ' + senha.edicao_nome_pendente"
                  >
                    ✏️ Pendente: {{ senha.edicao_nome_pendente }}
                    <span
                      class="ml-1 text-success font-weight-bold"
                      style="cursor: pointer"
                      @click="aprovarEdicaoNome(senha)"
                      >✔ Aprovar</span
                    >
                    <span
                      class="ml-1 text-danger font-weight-bold"
                      style="cursor: pointer"
                      @click="rejeitarEdicaoNome(senha)"
                      >✖ Rejeitar</span
                    >
                  </span>
                  <!-- Flag de edição de nome social pendente -->
                  <span
                    v-if="senha.nome_social_pendente"
                    class="badge badge-warning ml-1"
                    style="font-size: 0.75em"
                    :title="'Nome social solicitado: ' + senha.nome_social_pendente"
                  >
                    ✏️ Nome social: {{ senha.nome_social_pendente }}
                    <span
                      class="ml-1 text-success font-weight-bold"
                      style="cursor: pointer"
                      @click="aprovarEdicaoNomeSocial(senha)"
                      >✔ Aprovar</span
                    >
                    <span
                      class="ml-1 text-danger font-weight-bold"
                      style="cursor: pointer"
                      @click="rejeitarEdicaoNomeSocial(senha)"
                      >✖ Rejeitar</span
                    >
                  </span>
                </td>
                <td class="align-center text-center">
                  <span
                    v-if="senha.user_id == $store.state.user.id"
                    class="badge badge-danger"
                  >
                    Você iniciou o atendimento dessa senha!
                  </span>
                  <span v-else>
                    <template
                      v-if="
                        senha.atendimento &&
                        senha.atendimento.anotacao &&
                        senha.atendimento.anotacao.length
                      "
                    >
                      {{
                        senha.atendimento.anotacao[0].titulo.substr(0, 120) +
                        "..."
                      }}
                    </template>
                    <template v-else>Sem notas</template>
                  </span>
                </td>
                <td
                  v-if="thisSetor && thisSetor.mostra_classificacao"
                  class="d-none d-md-table-cell align-center text-center"
                >
                  <span
                    class="badge"
                    :style="
                      'background:' +
                      (senha.classificacao ? senha.classificacao.cor : '#999') +
                      ';'
                    "
                  >
                    {{
                      senha.classificacao_id && senha.classificacao
                        ? senha.classificacao.nome
                        : "Não classificado"
                    }}
                  </span>
                </td>
                <td class="d-none d-md-table-cell align-center text-center">
                  <span
                    v-if="
                      senha.prioridade &&
                      senha.prioridade.nome &&
                      getCorPrioridade(senha.prioridade.nome)
                    "
                    class="badge"
                    :style="
                      'background-color:' +
                      getCorPrioridade(senha.prioridade.nome) +
                      ';color:#fff;padding:4px 12px;border-radius:8px;font-weight:600;'
                    "
                  >
                    {{ getNomePrioridade(senha.prioridade.nome) }}
                  </span>
                  <span
                    v-else-if="senha.prioridade && senha.prioridade.nome"
                    class="badge badge-secondary"
                  >
                    {{ getNomePrioridade(senha.prioridade.nome) }}
                  </span>
                  <span v-else class="badge badge-secondary"
                    >Sem prioridade</span
                  >
                </td>
                <td class="d-none d-md-table-cell align-center text-center">
                  <span
                    :class="
                      'badge badge-' + (senha.status_badge || 'secondary')
                    "
                  >
                    {{ senha.status_text || "" }}
                  </span>
                  <br />
                  <span v-if="senha.reavaliar">
                    Atender após <b>{{ senha.reavaliar_f }}</b>
                  </span>
                  <span v-if="senha.user_id && senha.user && senha.user.name">
                    Atendido por <b>{{ senha.user.name }}</b>
                  </span>
                </td>
                <td class="text-center d-none d-lg-table-cell">
                  {{
                    (senha.data_entrada_diff || 0) >= 3600
                      ? Math.floor((senha.data_entrada_diff || 0) / 3600)
                          .toString()
                          .padStart(2, "0") +
                        ":" +
                        Math.floor(((senha.data_entrada_diff || 0) / 60) % 60)
                          .toString()
                          .padStart(2, "0") +
                        ":" +
                        Math.floor((senha.data_entrada_diff || 0) % 60)
                          .toString()
                          .padStart(2, "0")
                      : (senha.data_entrada_diff || 0) >= 60
                      ? "00:" +
                        Math.floor(((senha.data_entrada_diff || 0) / 60) % 60)
                          .toString()
                          .padStart(2, "0") +
                        ":" +
                        Math.floor((senha.data_entrada_diff || 0) % 60)
                          .toString()
                          .padStart(2, "0")
                      : "00:00:" +
                        Math.floor((senha.data_entrada_diff || 0) % 60)
                          .toString()
                          .padStart(2, "0")
                  }}
                </td>
                <td>
                  <button
                    class="btn btn-sm btn-success w-75"
                    @click="atender(senha.id)"
                    :disabled="
                      senha.status === 2 &&
                      senha.user_id != $store.state.user.id
                    "
                    title="Atender"
                  >
                    <i class="fas fa-play"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-primary w-75"
                    @click="atenderSilencioso(senha.id)"
                    :disabled="
                      senha.status === 2 &&
                      senha.user_id != $store.state.user.id
                    "
                    title="Atender (não chama no painel)"
                  >
                    <i class="fas fa-volume-mute" style="font-size: 11.5pt"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-danger mr-1 w-75"
                    data-toggle="modal"
                    :data-target="'#cancelamento_' + senha.id"
                    :disabled="
                      senha.status === 2 &&
                      senha.user_id != $store.state.user.id
                    "
                    title="Cancelar senha"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                  <div
                    class="modal fade"
                    :id="'cancelamento_' + senha.id"
                    tabindex="-1"
                    role="dialog"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header bg-danger">
                          <h5 class="modal-title text-light">
                            Cancelar senha
                            {{
                              senha.atendimento
                                ? senha.atendimento.prefixo
                                : ""
                            }}{{
                              senha.atendimento ? senha.atendimento.senha : ""
                            }}
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                          >
                            <span>&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center p-1">
                          Por favor, escolha o motivo do cancelamento
                          <v-select
                            v-model="motivo_cancelamento"
                            :options="motivos_cancelamento"
                            label="titulo"
                            :reduce="(motivo) => motivo.id"
                            class="vselect"
                          />
                          Descreva-o
                          <textarea
                            class="form-control"
                            rows="5"
                            v-model="cancelamento"
                          ></textarea>
                        </div>
                        <div class="modal-footer text-center">
                          <button
                            class="btn btn-sm btn-secondary my-1"
                            data-dismiss="modal"
                            @click="cancelamento = ''"
                          >
                            Não Cancelar
                          </button>
                          <button
                            class="btn btn-sm btn-danger my-1"
                            @click="cancelar(senha.id)"
                            data-dismiss="modal"
                          >
                            Cancelar Senha
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="table-bordered text-center" colspan="10">
                  <b>Não existem senhas na fila</b>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-12 mb-1">
          Selecione seu Setor
          <v-select
            v-model="setor"
            :options="setores"
            label="nome"
            :reduce="(setor) => setor.id"
            class="vselect"
            @input="getLocais"
          />
        </div>
        <div class="col-12 mb-1" v-if="setor">
          Selecione seu Local
          <v-select
            v-model="local"
            :options="locais"
            label="nome"
            :reduce="(local) => local.id"
            class="vselect"
            @input="onLocalSelecionado"
          />
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import swal from "sweetalert";

export default {
  name: "imageUpload",

  components: { BaseCrud, vSelect },

  data() {
    return {
      loader: 0,
      setor: null,
      local: null,
      setor_nome: "",
      local_nome: "",
      thisSetor: null,
      cancelamento: "",
      motivo_cancelamento: "",
      intervalo: null,
      classificacao: [],
      motivos_cancelamento: [],
      prioridades: [],
      setores: [],
      locais: [],
      senhas: [],
      idsConhecidos: [],
      buscandoSenhas: false,
      canalSetorAtivo: null,
      pendingRefresh: false,
      prioridadeCores: {
        Comum: "#0099cc",
        "Prioritário +60": "#ff9900",
        "Prioritário +80": "#cc0000",
        "Deficiente físico": "#a020f0",
        "Gestante (Grávida)": "#0066cc",
        "Autista - TEA": "#00cc66",
      },
      filtro: {},
      configuracao: { tipo_pessoa: "Pessoa" },
    };
  },

  methods: {
    aprovarEdicaoNome(senha) {
      const self = this;
      const tipoPessoa = self.configuracao.tipo_pessoa || "Pessoa";
      swal({
        title: "Aprovar alteração de nome?",
        text: `O nome "${senha.edicao_nome_pendente}" será aplicado a esta ${tipoPessoa}.`,
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", visible: true },
          confirm: { text: "Aprovar", className: "btn-success" },
        },
      }).then((confirmar) => {
        if (!confirmar) return;

        const api =
          self.$store.state.api +
          "atendimento_setor/" +
          senha.id +
          "/aprovar-edicao-nome";
        axios
          .post(api)
          .then(() => {
            const nomeAprovado = senha.edicao_nome_pendente;
            if (senha.atendimento && senha.atendimento.pessoa) {
              senha.atendimento.pessoa.nome = nomeAprovado;
            }
            senha.edicao_nome_pendente = null;
            swal({
              title: "Nome aprovado!",
              text: `O nome foi atualizado para "${nomeAprovado}".`,
              icon: "success",
              button: "OK",
            }).then(() => self.getSenhas());
          })
          .catch((error) => {
            self.$message(
              "Erro",
              error.response?.data?.message ||
                error.response?.data ||
                "Erro ao aprovar.",
              "error"
            );
          });
      });
    },
    rejeitarEdicaoNome(senha) {
      const self = this;
      swal({
        title: "Rejeitar alteração de nome?",
        text: `O nome "${senha.edicao_nome_pendente}" será descartado.`,
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", visible: true },
          confirm: { text: "Rejeitar", className: "btn-danger" },
        },
        dangerMode: true,
      }).then((confirmar) => {
        if (!confirmar) return;
        const api =
          self.$store.state.api +
          "atendimento_setor/" +
          senha.id +
          "/rejeitar-edicao-nome";
        axios
          .post(api)
          .then(() => {
            senha.edicao_nome_pendente = null;
            swal({
              title: "Nome rejeitado!",
              icon: "success",
              button: "OK",
            }).then(() => self.getSenhas());
          })
          .catch((error) => {
            self.$message(
              "Erro",
              error.response?.data?.message ||
                error.response?.data ||
                "Erro ao rejeitar.",
              "error"
            );
          });
      });
    },
    aprovarEdicaoNomeSocial(senha) {
      const self = this;
      const tipoPessoa = self.configuracao.tipo_pessoa || "Pessoa";
      swal({
        title: "Aprovar nome social?",
        text: `O nome social "${senha.nome_social_pendente}" será aplicado a esta ${tipoPessoa}.`,
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", visible: true },
          confirm: { text: "Aprovar", className: "btn-success" },
        },
      }).then((confirmar) => {
        if (!confirmar) return;

        const api =
          self.$store.state.api +
          "atendimento_setor/" +
          senha.id +
          "/aprovar-edicao-nome-social";
        axios
          .post(api)
          .then(() => {
            const nomeSocialAprovado = senha.nome_social_pendente;
            if (senha.atendimento && senha.atendimento.pessoa) {
              senha.atendimento.pessoa.nome_social = nomeSocialAprovado;
            }
            senha.nome_social_pendente = null;
            swal({
              title: "Nome social aprovado!",
              text: `O nome social foi atualizado para "${nomeSocialAprovado}".`,
              icon: "success",
              button: "OK",
            }).then(() => self.getSenhas());
          })
          .catch((error) => {
            self.$message(
              "Erro",
              error.response?.data?.message ||
                error.response?.data ||
                "Erro ao aprovar.",
              "error"
            );
          });
      });
    },
    rejeitarEdicaoNomeSocial(senha) {
      const self = this;
      swal({
        title: "Rejeitar nome social?",
        text: `O nome social "${senha.nome_social_pendente}" será descartado.`,
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", visible: true },
          confirm: { text: "Rejeitar", className: "btn-danger" },
        },
        dangerMode: true,
      }).then((confirmar) => {
        if (!confirmar) return;
        const api =
          self.$store.state.api +
          "atendimento_setor/" +
          senha.id +
          "/rejeitar-edicao-nome-social";
        axios
          .post(api)
          .then(() => {
            senha.nome_social_pendente = null;
            swal({
              title: "Nome social rejeitado!",
              icon: "success",
              button: "OK",
            }).then(() => self.getSenhas());
          })
          .catch((error) => {
            self.$message(
              "Erro",
              error.response?.data?.message ||
                error.response?.data ||
                "Erro ao rejeitar.",
              "error"
            );
          });
      });
    },
    resumoQuestionario(questionario) {
      const agrupado = [];

      (questionario || []).forEach((item) => {
        const existente = agrupado.find((linha) => linha.pergunta === item.pergunta);

        if (existente) {
          existente.respostas += ", " + item.resposta;
          return;
        }

        agrupado.push({ pergunta: item.pergunta, respostas: item.resposta });
      });

      return agrupado;
    },
    normalizeSenha(senha) {
      if (!senha) return senha;

      const STATUS_TEXT = {
        0: "Ausente",
        1: "Em fila",
        2: "Em atendimento",
        3: "Atendido",
        4: "Evadido",
        5: "Cancelado",
        8: "Espera",
        9: "Reavaliação",
      };
      const STATUS_BADGE = {
        0: "danger",
        1: "secondary",
        2: "primary",
        3: "success",
        4: "danger",
        5: "danger",
      };
      const VP_MAP = { 0: 0.5, 2: 2, 3: 3 };

      const n = Object.assign({}, senha);
      const nowMs = Date.now();
      const nowSec = Math.floor(nowMs / 1000);
      const parseTs = (str) =>
        str
          ? Math.floor(new Date(str.replace(" ", "T")).getTime() / 1000)
          : nowSec;
      const fmtDt = (str) => {
        const d = new Date(str.replace(" ", "T"));
        return (
          d.toLocaleDateString("pt-BR") +
          " às " +
          d.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
        );
      };

      // ── diffs de tempo ──────────────────────────────────────────────
      const entradaTs = parseTs(n.data_entrada);
      n.data_entrada_diff = nowSec - entradaTs;
      n.data_ultima_chamada_diff = n.data_ultima_chamada
        ? nowSec - parseTs(n.data_ultima_chamada)
        : null;

      // ── formatação de datas ─────────────────────────────────────────
      n.data_entrada_f = n.data_entrada ? fmtDt(n.data_entrada) : false;

      // ── reavaliação ─────────────────────────────────────────────────
      const reavaliacaoMs = n.reavaliacao
        ? new Date(n.reavaliacao.replace(" ", "T")).getTime()
        : null;
      n.reavaliar = reavaliacaoMs ? reavaliacaoMs > nowMs : false;
      if (reavaliacaoMs) {
        const hhmm = new Date(reavaliacaoMs).toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
        });
        n.reavaliacao_f = hhmm;
        n.reavaliar_f = hhmm;
      } else {
        n.reavaliacao_f = false;
        n.reavaliar_f = false;
      }

      // ── status ──────────────────────────────────────────────────────
      const status = n.status ?? 1;
      n.status_text = STATUS_TEXT[status] || "Em fila";
      n.status_badge =
        status === 8 || status === 9
          ? n.reavaliar
            ? "warning"
            : "success"
          : STATUS_BADGE[status] || "secondary";

      // ── pontuação ───────────────────────────────────────────────────
      const prioridade = n.prioridade_id ?? 1;
      const vp = VP_MAP[prioridade] ?? 1;
      const classCodRaw = n.classificacao?.classificacao;
      const classCod =
        classCodRaw != null
          ? Math.min(Math.max(parseInt(classCodRaw, 10), 0), 240)
          : 240;
      n.pontuacao = (nowSec - entradaTs) * vp * (241 - classCod);

      // ── atendimento ─────────────────────────────────────────────────
      if (n.atendimento) {
        n.atendimento = Object.assign({}, n.atendimento);

        n.atendimento.data_inicio_f = n.atendimento.data_inicio
          ? fmtDt(n.atendimento.data_inicio)
          : null;

        if (n.atendimento.pessoa) {
          const nome = n.atendimento.pessoa.nome_social || n.atendimento.pessoa.nome;
          if (nome == null || String(nome).toLowerCase() === "null") {
            n.atendimento.pessoa = null;
          } else {
            n.atendimento.pessoa = Object.assign({}, n.atendimento.pessoa);
            const dn = n.atendimento.pessoa.data_nascimento;
            if (dn) {
              const dnDate = new Date(dn.replace(" ", "T"));
              n.atendimento.pessoa.data_nascimento_f =
                dnDate.toLocaleDateString("pt-BR");
              // cálculo de idade sem new Date() extra
              const today = new Date();
              let y = today.getFullYear() - dnDate.getFullYear();
              let mo = today.getMonth() - dnDate.getMonth();
              let d = today.getDate() - dnDate.getDate();
              if (d < 0) {
                mo--;
                d += new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  0
                ).getDate();
              }
              if (mo < 0) {
                y--;
                mo += 12;
              }
              n.atendimento.pessoa.diff_idade = `${y} anos, ${mo} meses, ${d} dias`;
            } else {
              n.atendimento.pessoa.data_nascimento_f = null;
              n.atendimento.pessoa.diff_idade = null;
            }
          }
        }
      }

      return n;
    },
    getCorPrioridade(nomePrioridade) {
      if (nomePrioridade === "Maior de 60 anos")
        return this.prioridadeCores["Prioritário +60"];
      if (nomePrioridade === "Maior de 80 anos")
        return this.prioridadeCores["Prioritário +80"];
      return this.prioridadeCores[nomePrioridade] || null;
    },

    getNomePrioridade(nomePrioridade) {
      if (nomePrioridade === "Maior de 60 anos") return "Prioritário +60";
      if (nomePrioridade === "Maior de 80 anos") return "Prioritário +80";
      return nomePrioridade;
    },
    ordenarSenhas(listaSenhas) {
      return listaSenhas.slice().sort((senhaA, senhaB) => {
        // Só considerar a prioridade se a senha já esperou o tempo mínimo
        // (tempo_max_presenca_minutos) na fila. Caso contrário, tratar como
        // senha sem prioridade para que não suba imediatamente.
        const tempoEsperaA = senhaA.data_entrada_diff || 0; // segundos
        const tempoEsperaB = senhaB.data_entrada_diff || 0;

        const tempoMinA =
          senhaA.prioridade &&
          senhaA.prioridade.tempo_max_presenca_minutos != null
            ? Number(senhaA.prioridade.tempo_max_presenca_minutos)
            : null;
        const tempoMinB =
          senhaB.prioridade &&
          senhaB.prioridade.tempo_max_presenca_minutos != null
            ? Number(senhaB.prioridade.tempo_max_presenca_minutos)
            : null;

        // Só ativa a prioridade se já esperou o tempo mínimo (em minutos → segundos)
        const tempoA =
          tempoMinA !== null && tempoEsperaA >= tempoMinA * 60
            ? tempoMinA
            : null;
        const tempoB =
          tempoMinB !== null && tempoEsperaB >= tempoMinB * 60
            ? tempoMinB
            : null;

        if (tempoA === null && tempoB !== null) return 1;
        if (tempoB === null && tempoA !== null) return -1;
        if (tempoA !== null && tempoB !== null && tempoA !== tempoB)
          return tempoA - tempoB;

        const dataA = senhaA.data_entrada
          ? new Date(senhaA.data_entrada.replace(" ", "T"))
          : new Date(0);
        const dataB = senhaB.data_entrada
          ? new Date(senhaB.data_entrada.replace(" ", "T"))
          : new Date(0);
        if (dataA < dataB) return -1;
        if (dataA > dataB) return 1;

        return (senhaB.pontuacao || 0) - (senhaA.pontuacao || 0);
      });
    },
    tocarSom() {
      try {
        const audio = this.$el.querySelector("audio");
        if (audio) {
          audio.currentTime = 0;
          audio.play().catch(() => {});
        }
      } catch (erro) {}
    },
    notificarNovaSenha() {
      this.tocarSom();
      this.$toastr("add", {
        title: "Nova senha",
        msg: "Nova senha no setor",
        clickClose: true,
        timeout: 4000,
        position: "toast-top-right",
        style: { backgroundColor: "#17a2b8", color: "#fff" },
      });
    },

    onChamadorEvent(deltas) {
      const self = this;
      if (!Array.isArray(deltas) || deltas.length === 0) return;

      let hasNew = false;
      let changed = false;

      deltas.forEach((delta) => {
        if (delta.type === "remove") {
          const before = self.senhas.length;
          self.senhas = self.senhas.filter((s) => s.id !== delta.id);
          self.idsConhecidos = self.idsConhecidos.filter((id) => id !== delta.id);
          if (self.senhas.length !== before) changed = true;

        } else if (delta.type === "new") {
          if (!self.idsConhecidos.includes(delta.senha.id)) {
            const normalized = self.normalizeSenha(delta.senha);
            self.senhas.push(normalized);
            self.idsConhecidos.push(normalized.id);
            hasNew = true;
            changed = true;
          }

        } else if (delta.type === "update") {
          const normalized = self.normalizeSenha(delta.senha);
          const idx = self.senhas.findIndex((s) => s.id === normalized.id);
          if (idx !== -1) {
            self.$set(self.senhas, idx, {
              ...normalized,
              data_entrada_diff: self.senhas[idx].data_entrada_diff || 0,
            });
            changed = true;
          }
        }
      });

      if (hasNew) self.notificarNovaSenha();
      if (changed) self.senhas = self.ordenarSenhas(self.senhas);
    },

    atender(senhaId) {
      const self = this;
      self.$loading(true);
      clearInterval(self.intervalo);
      axios
        .post(self.$store.state.api + "atender/" + senhaId, {
          local_id: self.local,
        })
        .then(() => {
          self.$loading(false);
          self.$router.push("./atender/" + senhaId);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
          self.$loading(false);
        });
    },

    atenderSilencioso(senhaId) {
      const self = this;
      self.$loading(true);
      clearInterval(self.intervalo);
      axios
        .post(self.$store.state.api + "chamar_silencioso/" + senhaId, {
          local_id: self.local,
        })
        .then(() => {
          self.$loading(false);
          self.$router.push("./atender/" + senhaId);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
          self.$loading(false);
        });
    },

    cancelar(senhaId) {
      const self = this;
      self.$loading(true);
      axios
        .post(self.$store.state.api + "cancelar/" + senhaId, {
          motivo_cancelamento_id: self.motivo_cancelamento,
          cancelamento: self.cancelamento,
        })
        .then(() => {
          self.cancelamento = "";
          self.motivo_cancelamento = "";
          self.getSenhas();
          self.$loading(false);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
          self.$loading(false);
        });
    },

    chamarProximo() {
      const self = this;
      self.$loading(true);
      axios
        .post(self.$store.state.api + "proximo", { local_id: self.local })
        .then((response) => {
          self.$loading(false);
          self.$router.push("./atender/" + response.data.id);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
          self.$loading(false);
        });
    },

    chamarProximoAusente() {
      const self = this;
      self.$loading(true);
      axios
        .post(self.$store.state.api + "proximo-ausente", {
          local_id: self.local,
        })
        .then((response) => {
          self.$loading(false);
          self.$router.push("./atender/" + response.data.id);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
          self.$loading(false);
        });
    },

    getSenhas() {
      const self = this;
      clearInterval(self.intervalo);
      self.buscandoSenhas = true;

      axios
        .get(self.$store.state.api + "get_atendimento_setor/" + self.setor)
        .then((response) => {
          const listaSenhas = Array.isArray(response.data) ? response.data : [];
          const listaNorm = listaSenhas.map(self.normalizeSenha);
          self.idsConhecidos = listaNorm.map((senha) => senha.id);
          self.senhas = self.ordenarSenhas(listaNorm);
          self.buscandoSenhas = false;

          self.intervalo = setInterval(() => {
            self.senhas.forEach((senha) => {
              senha.data_entrada_diff = (senha.data_entrada_diff || 0) + 1;
            });
          }, 1000);

          self.$loading(false);
        })
        .catch((erro) => {
          self.buscandoSenhas = false;
          self.$loading(false);
          self.$message("Erro", erro.response.data, "error");
        });
    },

    filtrar() {
      const self = this;

      // Se todos os filtros estiverem vazios, volta para o GET padrão
      // (que já aplica o filtro de últimas 5 horas no backend)
      const temFiltroAtivo = Object.keys(self.filtro).some((key) => {
        if (key === "setor") return false;
        const val = self.filtro[key];
        return val !== "" && val !== null && val !== undefined;
      });

      if (!temFiltroAtivo) {
        self.$loading(true);
        self.getSenhas();
        return;
      }

      self.$loading(true);
      self.filtro.setor = self.setor;

      axios
        .post(self.$store.state.api + "filtro-chamador", self.filtro)
        .then((response) => {
          self.$loading(false);
          const lista = Array.isArray(response.data) ? response.data : [];
          self.senhas = self.ordenarSenhas(lista.map(self.normalizeSenha));
        })
        .catch((erro) => {
          self.$loading(false);
          self.$message("Erro", erro.response.data, "error");
        });
    },

    getClassificacao() {
      const self = this;
      const classificacoesCache = self.$store.state.classificacoes_cache;

      if (classificacoesCache && classificacoesCache.length) {
        self.classificacao = classificacoesCache;
        self.setLoader(25);
        return;
      }

      axios
        .get(self.$store.state.api + "classificacoes?ativo=1&paginated=false")
        .then((response) => {
          self.classificacao = response.data.data;
          self.$store.commit("setClassificacoesCache", response.data.data);
          self.setLoader(25);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
        });
    },

    getMotivoCancelamento() {
      const self = this;
      const motivosCache = self.$store.state.motivos_cancelamento;

      if (motivosCache && motivosCache.length) {
        self.motivos_cancelamento = motivosCache;
        return;
      }

      self.$loading(true);
      axios
        .get(self.$store.state.api + "motivo_cancelamentos/")
        .then((response) => {
          self.motivos_cancelamento = response.data.data;
          self.$store.commit("setMotivosCancelamento", response.data.data);
          self.$loading(false);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
          self.$loading(false);
        });
    },

    getPrioridades() {
      const self = this;
      const prioridadesCache = self.$store.state.prioridades_cache;

      if (prioridadesCache && prioridadesCache.length) {
        self.prioridades = prioridadesCache;
        return;
      }

      self.$loading(true);
      axios
        .get(self.$store.state.api + "prioridades?paginated=false")
        .then((response) => {
          self.prioridades = response.data.data;
          self.$store.commit("setPrioridadesCache", response.data.data);
          self.$loading(false);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
          self.$loading(false);
        });
    },

    getLocais() {
      const self = this;
      const locaisCache = self.$store.state.locais_chamador[self.setor];

      if (locaisCache && locaisCache.length) {
        self.locais = locaisCache;
        return;
      }

      axios
        .get(self.$store.state.api + "locais-chamador/" + self.setor)
        .then((response) => {
          self.locais = response.data;
          self.$store.commit("setLocaisChamador", {
            setorId: self.setor,
            locais: response.data,
          });
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
        });
    },

    getSetores() {
      const self = this;

      axios
        .get(
          self.$store.state.api +
            "setores-chamador/" +
            self.$store.state.user.id +
            "?updated_at=" +
            Date.now()
        )
        .then((response) => {
          const setoresComLocal = response.data.filter(
            (setor) => setor.possui_local
          );
          self.setores = setoresComLocal;
          self.$store.commit("setSetoresChamador", setoresComLocal);
          self.setLoader(50);
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
        });
    },

    getSetorNome() {
      const self = this;
      const setoresCache = self.$store.state.setores_chamador;

      if (setoresCache && setoresCache.length) {
        const setorEncontrado = setoresCache.find(
          (setor) => setor.id === self.setor
        );
        if (setorEncontrado) {
          self.setor_nome = setorEncontrado.nome;
          self.thisSetor = setorEncontrado;
          return;
        }
      }

      axios
        .get(
          self.$store.state.api +
            "setores-chamador/" +
            self.$store.state.user.id
        )
        .then((response) => {
          const setoresComLocal = response.data.filter(
            (setor) => setor.possui_local
          );
          self.setores = setoresComLocal;
          self.$store.commit("setSetoresChamador", setoresComLocal);
          const setorEncontrado = setoresComLocal.find(
            (setor) => setor.id === self.setor
          );
          if (setorEncontrado) {
            self.setor_nome = setorEncontrado.nome;
            self.thisSetor = setorEncontrado;
          }
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
        });
    },

    getLocalNome() {
      const self = this;
      const locaisCache = self.$store.state.locais_chamador[self.setor];

      if (locaisCache && locaisCache.length) {
        const localEncontrado = locaisCache.find(
          (local) => local.id === self.local
        );
        if (localEncontrado) {
          self.local_nome = localEncontrado.nome;
          return;
        }
      }

      axios
        .get(self.$store.state.api + "locais-chamador/" + self.setor)
        .then((response) => {
          const listaLocais = response.data;
          self.locais = listaLocais;
          self.$store.commit("setLocaisChamador", {
            setorId: self.setor,
            locais: listaLocais,
          });
          const localEncontrado = listaLocais.find(
            (local) => local.id === self.local
          );
          if (localEncontrado) self.local_nome = localEncontrado.nome;
        })
        .catch((erro) => {
          self.$message("Erro", erro.response.data, "error");
        });
    },

    onLocalSelecionado() {
      this.getSenhas();
      this.iniciarWebSocket(this.setor);
    },

    iniciarWebSocket(setorId) {
      const self = this;
      const setorAnterior = self.$store.state.user.setor;
      const localAnterior = self.$store.state.user.local;

      self.getSetorNome();
      self.getLocalNome();
      self.$store.commit("setChamador", {
        setor: self.setor,
        local: self.local,
      });

      if (setorAnterior !== self.setor || localAnterior !== self.local) {
        axios
          .post(self.$store.state.api + "login_chamador", {
            id: self.$store.state.user.id,
            setor: self.setor,
            local: self.local,
          })
          .catch(() => {});
      }

      clearInterval(self.intervalo);

      setTimeout(() => {
        if (self.canalSetorAtivo !== null) {
          try {
            Echo.leave(`chamador.${self.canalSetorAtivo}`);
          } catch (erro) {}
        }

        self.canalSetorAtivo = setorId;

        Echo.private(`chamador.${setorId}`).listen(".ChamadorEvent", (data) => {
          if (!data || !data[0]) return;
          const senhasDoEvento = Array.isArray(data[0]) ? data[0] : [];
          self.onChamadorEvent(senhasDoEvento);
        });
      }, 3000);
    },

    escutarWebSocketGlobal() {
      const self = this;
      if (!window.Echo) return;

      window.Echo.channel("atendimento-setor-updates").listen(
        ".atendimento.setor.updated",
        (evento) => {
          self.handleSetorAlteradoWebSocket(evento);
        }
      );
    },

    handleSetorAlterado(dados) {
      this.senhas = this.senhas.filter(
        (senha) => senha.id !== dados.atendimento_setor_id
      );
      this.idsConhecidos = this.idsConhecidos.filter(
        (idSenha) => idSenha !== dados.atendimento_setor_id
      );
    },

    handleSetorAlteradoWebSocket(evento) {
      const self = this;
      const { atendimento_setor, action } = evento;

      if (action !== "setor_alterado") return;

      const numeroSenha = atendimento_setor.atendimento
        ? atendimento_setor.atendimento.prefixo +
          atendimento_setor.atendimento.senha
        : "";

      if (atendimento_setor.setor_id !== self.setor) {
        self.senhas = self.senhas.filter(
          (senha) => senha.id !== atendimento_setor.id
        );
        self.idsConhecidos = self.idsConhecidos.filter(
          (idSenha) => idSenha !== atendimento_setor.id
        );
        self.$toastr("add", {
          title: "Atualização",
          msg: `Senha ${numeroSenha} foi transferida para outro setor`,
          clickClose: true,
          timeout: 4000,
          position: "toast-top-right",
          style: { backgroundColor: "#17a2b8", color: "#fff" },
        });
      } else {
        self.getSenhas();
        self.$toastr("add", {
          title: "Nova Senha",
          msg: `Senha ${numeroSenha} foi transferida para seu setor`,
          clickClose: true,
          timeout: 4000,
          position: "toast-top-right",
          style: { backgroundColor: "#17a2b8", color: "#fff" },
        });
      }
    },

    logoutChamador() {
      const self = this;
      self.$loading(true);

      if (self.canalSetorAtivo !== null) {
        try {
          Echo.leave(`chamador.${self.canalSetorAtivo}`);
        } catch (erro) {}
        self.canalSetorAtivo = null;
      }

      self.$store.state.user.setor = null;
      self.$store.state.user.local = null;
      self.setor = null;
      self.local = null;
      self.loader = 0;
      self.setores = [];
      self.senhas = [];
      self.idsConhecidos = [];

      self.$store.commit("clearChamadorCache");
      clearInterval(self.intervalo);

      axios
        .post(
          self.$store.state.api + "logout_chamador/" + self.$store.state.user.id
        )
        .then(() => {
          self.setLoader(50);
          self.$loading(false);
        })
        .catch((erro) => {
          self.setLoader(50);
          self.$message("Erro", erro.response.data, "error");
          self.$loading(false);
        });

      self.getSetores();
    },

    setLoader(quantidade) {
      const self = this;
      let progresso = 0;
      const intervaloLoader = setInterval(() => {
        self.loader++;
        progresso++;
        if (progresso === quantidade) clearInterval(intervaloLoader);
      }, 15);
    },

    getConfiguracao() {
      const self = this;
      axios
        .get(self.$store.state.api + "configuracoes/")
        .then((response) => {
          self.configuracao = response.data.data[0];
        })
        .catch(() => {});
    },
  },

  mounted() {
    const self = this;
    document.addEventListener(
      "click",
      function desbloquearAudio() {
        const audio = self.$el.querySelector("audio");
        if (audio) {
          audio
            .play()
            .then(() => {
              audio.pause();
              audio.currentTime = 0;
            })
            .catch(() => {});
        }
        document.removeEventListener("click", desbloquearAudio);
      },
      { once: true }
    );

    self.setLoader(25);
    self.getClassificacao();
    self.getMotivoCancelamento();
    self.getPrioridades();
    self.getConfiguracao();

    self.$root.$on("senha-setor-alterado", self.handleSetorAlterado);
    self.escutarWebSocketGlobal();

    setTimeout(() => {
      if (self.$store.state.user.setor) {
        self.setor = self.$store.state.user.setor;
        self.getSetorNome();
        self.setLoader(50);
      } else {
        self.getSetores();
      }

      if (self.$store.state.user.local) {
        self.local = self.$store.state.user.local;
        self.getLocalNome();
        self.getSenhas();
        self.iniciarWebSocket(self.$store.state.user.setor);
      }
    }, 1000);
  },

  beforeDestroy() {
    const self = this;
    self.$loading(true);
    self.$root.$off("senha-setor-alterado", self.handleSetorAlterado);

    if (self.canalSetorAtivo !== null) {
      try {
        Echo.leave(`chamador.${self.canalSetorAtivo}`);
      } catch (erro) {}
    }
    if (window.Echo) window.Echo.leaveChannel("atendimento-setor-updates");

    clearInterval(self.intervalo);
    self.$loading(false);
  },
};
</script>

<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>
